<template>
  <div>
    <v-card class="elevation-6">
      <v-card-title class="d-flex justify-space-between align-center">
        <span v-t="title"></span>
        <div class="d-flex align-center">
          <div v-if="basketItems.length > 0" class="d-flex align-center mr-2">
            <v-tooltip bottom nudge-bottom="2" content-class="custom-tooltip" open-delay="200" close-delay="0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  color="light-blue"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="mostrarPresupuestoPedidoDesdeProductos = true"
                >
                  {{ $t('producto.modals.presupuestoPedido.basketCount', { count: basketItems.length }) }}
                </v-btn>
              </template>
              <span>{{ $t('producto.modals.presupuestoPedido.openModal') }}</span>
            </v-tooltip>
            <v-tooltip bottom nudge-bottom="2" content-class="custom-tooltip" open-delay="200" close-delay="0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="error"
                  class="ml-1"
                  v-bind="attrs"
                  v-on="on"
                  @click="limpiarCanastaPresupuesto"
                >
                  <v-icon small>mdi-close-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('producto.modals.presupuestoPedido.clearBasket') }}</span>
            </v-tooltip>
          </div>
          <div v-if="ordenCompraBasketItems.length > 0" class="d-flex align-center mr-2">
            <v-tooltip bottom nudge-bottom="2" content-class="custom-tooltip" open-delay="200" close-delay="0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  color="light-blue"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="mostrarOrdenCompraDesdeProductos = true"
                >
                  {{ $t('producto.modals.ordenCompra.basketCount', { count: ordenCompraBasketItems.length }) }}
                </v-btn>
              </template>
              <span>{{ $t('producto.modals.ordenCompra.openModal') }}</span>
            </v-tooltip>
            <v-tooltip bottom nudge-bottom="2" content-class="custom-tooltip" open-delay="200" close-delay="0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="error"
                  class="ml-1"
                  v-bind="attrs"
                  v-on="on"
                  @click="limpiarCanastaOrdenCompra"
                >
                  <v-icon small>mdi-close-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('producto.modals.ordenCompra.clearBasket') }}</span>
            </v-tooltip>
          </div>
          <v-tooltip bottom nudge-bottom="2" content-class="custom-tooltip" open-delay="200" close-delay="0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
                @click="$refs.list.openEditTableDialog()"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('producto.actions.editarTabla') }}</span>
          </v-tooltip>
          <v-tooltip bottom nudge-bottom="2" content-class="custom-tooltip" open-delay="200" close-delay="0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                fab
                color="primary"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
                @click="create"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('common.create') }}</span>
          </v-tooltip>
        </div>
      </v-card-title>
      <v-card-subtitle v-t="subtitle" />
      <v-card-text>
        <producto-list
                       ref="list"
                       @update="update"
                       @delete="remove"
                       @show="show"
                       @addProductoToCsv="addProductoToCsv"
                       @onItemUpdated="onItemUpdated"
                       @createOferta="openCreateOfertaModal"
                       @transferirStock="openTransferirStockModal"
                       @agregarStock="openAgregarStockModal"
                       @cambioMasivoPrecio="openCambioMasivoPrecioModal"
                       @edicionMasivaAtributos="openEdicionMasivaAtributosModal"
                       @addToPresupuestoPedido="onAddToPresupuestoPedido"
                       @addToOrdenCompra="onAddToOrdenCompra"
        />
      </v-card-text>
    </v-card>

    <producto-create v-if="creating" 
                        :open="creating"
                        v-on:itemCreated="onItemCreated" 
                        v-on:close="creating=false" 
        />
        
    <producto-update v-if="updating" 
                        :open="updating"
                        :item="itemToEdit" 
                        v-on:itemUpdated="onItemUpdated" 
                        v-on:close="updating=false" 
        />
          
    <producto-show v-if="showing" 
                           :open="showing" 
                           :item="itemToShow"  
                           v-on:close="showing=false" 
         />

    <producto-delete v-if="deleting" 
                         :open="deleting"
                         :item="itemToDelete"  
                         v-on:itemDeleted="onItemDeleted" 
                         v-on:close="deleting=false" 
        />

    <producto-create-oferta-modal
            v-if="creatingOferta"
            :open="creatingOferta"
            :selected-productos="selectedProductosForOferta"
            v-on:close="creatingOferta=false"
        />

    <producto-transferir-stock-modal
            v-if="transferiendoStock"
            :open="transferiendoStock"
            :selected-productos="selectedProductosForTransferencia"
            v-on:close="transferiendoStock=false"
            v-on:success="onStockTransferido"
            v-on:error="onStockTransferError"
            v-on:info="onStockTransferInfo"
        />

    <producto-agregar-stock-modal
            v-if="agregandoStock"
            :open="agregandoStock"
            :selected-productos="selectedProductosForAgregarStock"
            v-on:close="agregandoStock=false"
            v-on:success="onStockAgregado"
            v-on:error="onStockAgregadoError"
        />

    <producto-cambio-masivo-modal
            v-if="cambiandoPreciosMasivo"
            :open="cambiandoPreciosMasivo"
            :selected-productos="selectedProductosForCambioMasivo"
            v-on:close="cambiandoPreciosMasivo=false"
            v-on:success="onPreciosActualizados"
            v-on:error="onPreciosActualizadosError"
            v-on:info="onPreciosInfo"
        />

    <producto-edicion-masiva-atributos-modal
            v-if="editandoAtributosMasivo"
            :open="editandoAtributosMasivo"
            :selected-productos="selectedProductosForEdicionMasiva"
            v-on:close="editandoAtributosMasivo=false"
            v-on:success="onAtributosMasivosSuccess"
            v-on:error="onAtributosMasivosError"
        />

    <presupuesto-pedido-desde-productos-create
            v-if="basketItems.length > 0"
            :open="mostrarPresupuestoPedidoDesdeProductos"
            :items="basketItems"
            v-on:created="onPresupuestoPedidoCreated"
            v-on:close="mostrarPresupuestoPedidoDesdeProductos = false"
        />

    <orden-compra-desde-productos-create
            v-if="ordenCompraBasketItems.length > 0"
            :open="mostrarOrdenCompraDesdeProductos"
            :items="ordenCompraBasketItems"
            v-on:created="onOrdenCompraCreated"
            v-on:close="mostrarOrdenCompraDesdeProductos = false"
        />

    <snackbar v-model="flash"/>
  </div>
</template>

<script>
    
    import ProductoCreate from "../ProductoCreate";
    import ProductoUpdate from "../ProductoUpdate";
    import ProductoDelete from "../ProductoDelete";
    import ProductoShow from "../ProductoShow";
    import ProductoList from "../ProductoList";
    import ProductoCreateOfertaModal from "../ProductoCreateOfertaModal";
    import ProductoTransferirStockModal from "../ProductoTransferirStockModal";
    import ProductoAgregarStockModal from "../ProductoAgregarStockModal";
    import ProductoCambioMasivoModal from "../ProductoCambioMasivoModal/ProductoCambioMasivoModal";
    import ProductoEdicionMasivaAtributosModal from "../ProductoEdicionMasivaAtributosModal/ProductoEdicionMasivaAtributosModal.vue";
    import PresupuestoPedidoDesdeProductosCreate from "../PresupuestoPedidoDesdeProductosCreate";
    import OrdenCompraDesdeProductosCreate from "../OrdenCompraDesdeProductosCreate/OrdenCompraDesdeProductosCreate.vue";
     import {Snackbar} from "@dracul/common-frontend"

     export default {
        name: "ProductoCrud",
        components: {
            Snackbar,
            ProductoCreate,
            ProductoUpdate,
            ProductoShow,
            ProductoList,
            ProductoDelete,
            ProductoCreateOfertaModal,
            ProductoTransferirStockModal,
            ProductoAgregarStockModal,
            ProductoCambioMasivoModal,
            ProductoEdicionMasivaAtributosModal,
            PresupuestoPedidoDesdeProductosCreate,
            OrdenCompraDesdeProductosCreate,
        },
        data() {
            return {
                title: 'producto.title',
                subtitle: 'producto.subtitle',
                flash: null,
                creating: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
                creatingOferta: false,
                selectedProductosForOferta: [],
                transferiendoStock: false,
                selectedProductosForTransferencia: [],
                agregandoStock: false,
                selectedProductosForAgregarStock: [],
                cambiandoPreciosMasivo: false,
                selectedProductosForCambioMasivo: [],
                editandoAtributosMasivo: false,
                selectedProductosForEdicionMasiva: [],
                basketItems: [],
                mostrarPresupuestoPedidoDesdeProductos: false,
                ordenCompraBasketItems: [],
                mostrarOrdenCompraDesdeProductos: false,
            }
        },
        methods: {
            //On
            onItemCreated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.created")
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.updated")
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.deleted")
            },
            //Open
            create() {
                this.creating = true
            },
            update(item) {
                this.updating = true
                this.itemToEdit = item
            },
            show(item) {
                this.showing = true
                this.itemToShow = item
            },
            remove(item) {
                if (item.stock === 0) {
                    this.deleting = true
                    this.itemToDelete = item
                } else {
                    this.flash= this.$t("producto.errorHasStock")
                }
                
            },
            addProductoToCsv() {
                this.flash= this.$t("producto.addedToCsv")
            },
            openCreateOfertaModal(selectedProductos) {
                this.selectedProductosForOferta = selectedProductos;
                this.creatingOferta = true;
            },
            openTransferirStockModal(selectedProductos) {
                this.selectedProductosForTransferencia = selectedProductos;
                this.transferiendoStock = true;
            },
            onStockTransferido(mensaje) {
                this.$refs.list.fetch();
                this.flash = mensaje || this.$t("producto.modals.transferirStock.success");
            },
            onStockTransferError(mensaje) {
                this.flash = mensaje || this.$t("producto.modals.transferirStock.errorTransferencia");
            },
            onStockTransferInfo(mensaje) {
                this.flash = mensaje;
            },
            openAgregarStockModal(selectedProductos) {
                this.selectedProductosForAgregarStock = selectedProductos;
                this.agregandoStock = true;
            },
            onStockAgregado(mensaje) {
                this.$refs.list.fetch();
                this.$refs.list.clearSelection();
                this.selectedProductosForAgregarStock = [];
                this.flash = mensaje || this.$t("producto.modals.agregarStock.success");
            },
            onStockAgregadoError(mensaje) {
                this.flash = mensaje || this.$t("producto.modals.agregarStock.error");
            },
            openCambioMasivoPrecioModal(selectedProductos) {
                this.selectedProductosForCambioMasivo = selectedProductos;
                this.cambiandoPreciosMasivo = true;
            },
            onPreciosActualizados(mensaje) {
                this.$refs.list.fetch();
                this.$refs.list.clearSelection(); // Limpiar selección en la tabla
                this.selectedProductosForCambioMasivo = []; // Limpiar selección en memoria
                this.flash = mensaje || this.$t("producto.modals.cambioMasivoPrecio.success");
            },
            onPreciosActualizadosError(mensaje) {
                this.flash = mensaje || this.$t("producto.modals.cambioMasivoPrecio.error");
            },
            onPreciosInfo(mensaje) {
                this.flash = mensaje;
            },
            openEdicionMasivaAtributosModal(selectedProductos) {
                this.selectedProductosForEdicionMasiva = selectedProductos;
                this.editandoAtributosMasivo = true;
            },
            onAtributosMasivosSuccess(mensaje) {
                this.$refs.list.fetch();
                this.$refs.list.clearSelection();
                this.selectedProductosForEdicionMasiva = [];
                this.flash = mensaje || this.$t("producto.modals.edicionMasivaAtributos.success");
            },
            onAtributosMasivosError(mensaje) {
                this.flash = mensaje || this.$t("producto.modals.edicionMasivaAtributos.error");
            },
            onAddToPresupuestoPedido(selectedProductos) {
                const existingIds = this.basketItems.map((b) => String(b.product.id));
                for (const p of selectedProductos || []) {
                    const id = String(p.id || p._id);
                    if (!existingIds.includes(id)) {
                        this.basketItems.push({ product: p, cantidad: 1 });
                        existingIds.push(id);
                    }
                }
                if (this.$refs.list) this.$refs.list.clearSelection();
            },
            onPresupuestoPedidoCreated() {
                this.basketItems = [];
                this.mostrarPresupuestoPedidoDesdeProductos = false;
            },
            limpiarCanastaPresupuesto() {
                this.basketItems = [];
                this.mostrarPresupuestoPedidoDesdeProductos = false;
            },
            onAddToOrdenCompra(selectedProductos) {
                const existingIds = this.ordenCompraBasketItems.map((b) => String(b.product.id));
                for (const p of selectedProductos || []) {
                    const id = String(p.id || p._id);
                    if (!existingIds.includes(id)) {
                        this.ordenCompraBasketItems.push({ product: p, cantidad: 1 });
                        existingIds.push(id);
                    }
                }
                if (this.$refs.list) this.$refs.list.clearSelection();
            },
            onOrdenCompraCreated() {
                this.ordenCompraBasketItems = [];
                this.mostrarOrdenCompraDesdeProductos = false;
            },
            limpiarCanastaOrdenCompra() {
                this.ordenCompraBasketItems = [];
                this.mostrarOrdenCompraDesdeProductos = false;
            },
        }
        
    }
</script>

<style>
.custom-tooltip {
  background-color: #424242 !important;
  opacity: 1 !important;
}

.custom-tooltip span {
  color: white !important;
}
</style>

